import { ReactNode } from "react";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";
import { DisclaimersSkeleton, FlightSelectionSkeleton, PassengerTileSkeleton, SSRTypeSelectionSkeleton } from "./SSR.skeleton.shared";

export default function SSRSkeletonMob({ stepButtons }: { stepButtons?: ReactNode }) {
  return (
    <>
      <div className="flex w-full flex-col gap-3">
        <div className="flex flex-col gap-0.5">
          <SkeletonBox className="h-7 w-44" />
          <SkeletonBox className="h-4 w-64 max-w-full" />
        </div>

        <SSRTypeSelectionSkeleton block />

        <div className="flex flex-col gap-6 rounded-xl">
          <div className="flex flex-col gap-5 rounded-md border-t border-border-minimal bg-background-default p-3 shadow-sm">
            <div className="flex w-full items-center gap-2">
              <SkeletonBox className="h-10 w-10 shrink-0 rounded-sm" />
              <SkeletonBox className="h-6 w-40" />
            </div>
            <FlightSelectionSkeleton />
            <div className="flex flex-col gap-1">
              <SkeletonBox className="h-4 w-16" />
              <div className="w-full rounded-md bg-background-minimal p-2 px-4">
                <PassengerTileSkeleton />
              </div>
            </div>
          </div>

          <div className="rounded-md bg-background-minimal p-2">
            <SkeletonBox className="h-96 w-full rounded-xl" />
          </div>
        </div>

        <DisclaimersSkeleton />
      </div>
      {stepButtons}
    </>
  );
}
